import React, { useState } from 'react';
import { ACCOUNT_ICON } from "assets/constants/Icons";
import moment from 'moment';
import ShowToast from 'components/ShowToast';
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from "assets/constants/Constants";
import { createSubscriptionCall, updateSubscriptionCall } from "lib/axiosUtils";

const CreateSubscription = (props) => {
    const [selectedSubscription, setSelectedSubscription] = useState(props.location.state ? props.location.state.subscriptionname : "");
    const [selectedPrice, setSelectedPrice] = useState(props.location.state ? props.location.state.price : "");
    const [selectedDuration, setSelectedDuration] = useState(props.location.state ? props.location.state.duration : "");
    const [selectedCredits, setSelectedCredits] = useState(props.location.state ? props.location.state.credits : "");
    const [subscriptionId] = useState(props.location.state ? props.location.state.subscriptionId : null);
    const [error, setError] = useState({});

    const changeSubscription = (event) => {
        setSelectedSubscription(event.target.value);
    }

    const changePrice = (event) => {
        const regularExpression = /^[0-9\b]+$/;
        if (event.target.value === '' || regularExpression.test(event.target.value)) {
            setSelectedPrice(event.target.value);
        }
    }

    const changeDuration = (event) => {
        const regularExpression = /^[0-9\b]+$/;
        if (event.target.value === '' || regularExpression.test(event.target.value)) {
            setSelectedDuration(event.target.value);
        }
    }

    const changeCredits = (event) => {
        const regularExpression = /^[0-9\b]+$/;
        if (event.target.value === '' || regularExpression.test(event.target.value)) {
            setSelectedCredits(event.target.value);
        }
    }

    const validateSubscription = () => {
        const validateFlag = validate();
        if (validateFlag) {
            createSubscription();
        }
        else {
            ShowToast('Please enter required data', TYPE_FAIL, INTERVAL, null, "");
        }
    }

    const validate = () => {
        let isValid = true;
        let error = {};
       
        if (selectedSubscription === "") {
            isValid = false;
            error.selectedSubscription = "Please Enter subscription name";
        }
        if (!selectedPrice) {
            isValid = false;
            error.selectedPrice = "Please Enter subscription Price";
        }
        if (!selectedCredits) {
            isValid = false;
            error.selectedCredits = "Please Enter Credits for Subscription";
        }
        if (!selectedDuration) {
            isValid = false;
            error.selectedDuration = "Please Enter subscription duration";
        }
        setError(error);
        return isValid;
    }

    const cancelHandler = () => {
        window.location.href = "/subscription";
      }

    const createSubscription = async () => {
        const subscriptiionParams = {
            subscriptionName: selectedSubscription,
            subscriptionPrice: selectedPrice,
            subscriptionDuration: selectedDuration,
            subscriptionCredits: selectedCredits          
        };
        try {
            if (subscriptionId) {
                await updateSubscriptionCall({}, subscriptiionParams, subscriptionId);
            }
            else {
                await createSubscriptionCall({}, subscriptiionParams);
            }
            
            ShowToast(`subscription ${subscriptionId ? "Updated" : "Created"} successfully`, TYPE_SUCCESS, INTERVAL, props, "/subscription");
        }
        catch (error) {
            console.log(`Error occurred while ${subscriptionId ? "updating" : "creating"} subscription`, error);
        }
    }

    return (
        <div className="main-content">
            <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
                <div className="col-md-10 sm_device"><i className={`${ACCOUNT_ICON}`}></i> Subscription Creation</div>
                <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={``}></i> {moment().format("DD MMM YYYY")}</div>
            </div>
            <div className="add-user-wrapper">
                <div className="mx-auto text-left border create-user-div">
                    <div className="user-icon-wrapper"></div>
                    <div style={{ padding: "0 50px", marginBottom: "20px", paddingTop: ".25rem" }} >
                        <div className="row mt-0">
                            <div className="input-label-group col-md-6">
                            <label className="form-label-outside" htmlFor="general-information-skills">Subscription Name</label><span className="text-danger"> *</span>
                                <div className="form-wrap-inner">
                                    <input
                                        className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                        placeholder={`Enter Subscription Name`}
                                        value={selectedSubscription}
                                        onChange={changeSubscription}
                                    />
                                </div>
                                <div className="text-danger error-msg">
                                    {error.selectedSubscription}
                                </div>
                            </div>
                            <div className="input-label-group col-md-6">
                            <label className="form-label-outside" htmlFor="general-information-skills">Price <span className="text-danger">*</span></label>
                                <input
                                    className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    placeholder={`Enter Price`}
                                    value={selectedPrice}
                                    onChange={changePrice}
                                />
                                <div className="text-danger error-msg">
                                    {error.selectedPrice}
                                </div>
                            </div>
                        </div>
                        <div className="row mt-0">
                            <div className="input-label-group col-md-6">
                            <label className="form-label-outside" htmlFor="general-information-skills">Duration(In Days)</label><span className="text-danger"> *</span>
                                <div className="form-wrap-inner">
                                    <input
                                        className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                        placeholder={`Enter Duration`}
                                        value={selectedDuration}
                                        onChange={changeDuration}
                                    />
                                </div>
                                <div className="text-danger error-msg">
                                    {error.selectedDuration}
                                </div>
                            </div>
                            <div className="input-label-group col-md-6">
                            <label className="form-label-outside" htmlFor="general-information-skills">Credits <span className="text-danger">*</span></label>
                                <input
                                    className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                    placeholder={`Enter Credits`}
                                    value={selectedCredits}
                                    onChange={changeCredits}
                                />
                                <div className="text-danger error-msg">
                                    {error.selectedCredits}
                                </div>
                            </div>
                        </div>
                        <div className="row mt-0 mt-4 mb-5 display-inline">
                            <div className="form-button-div">
                                <button className="brand-button ml-5" onClick={validateSubscription}>{subscriptionId ? "Update" : "Create"} </button>                               
                                 <button className="cancel_button ml-5" onClick={cancelHandler}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row dummy_row"></div>
        </div>
    )
}

export default CreateSubscription;